import pathOr from "ramda/src/pathOr";

export const pathOrNA = pathOr("N/A");
